import { render, staticRenderFns } from "./BpExportButton.vue?vue&type=template&id=d87a30ca&scoped=true&"
import script from "./BpExportButton.vue?vue&type=script&lang=js&"
export * from "./BpExportButton.vue?vue&type=script&lang=js&"
import style0 from "./BpExportButton.vue?vue&type=style&index=0&id=d87a30ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87a30ca",
  null
  
)

export default component.exports